import React, { useContext } from 'react';
import store from '../../store';
import PropTypes from 'prop-types';
import { signOut } from '../../constants';
// Material components
import { Button } from '@material-ui/core';
// Styles
import { makeStyles } from '@material-ui/core/styles';

const darkBtn = {
    color: 'black',
    border: '1px solid black',
}

const lightBtn = {
    color: 'white',
    border: '1px solid white',
}

const useStyles = makeStyles((theme) => ({
    backBtn: {
        ...lightBtn,
        position: 'fixed',
        top: 70,
        left: 10
    },
    editBtn: {
        ...darkBtn
    },
    logoutBtn: {
        ...darkBtn,
        width: '100%',
    },
    defaultLightBtn: {
        borderRadius: 5,
        backgroundColor: 'white',
        color: 'black',
        border: '1px solid #2c2727',
        '&:hover': {
            color: 'white',
            backgroundColor: '#2c2727',
        }
    },
    defaultDarkBtn: {
        borderRadius: 5,
        backgroundColor: '#2c2727',
        color: 'white',
        border: '1px solid #2c2727',
        '&:hover': {
            color: 'black',
            border: '1px solid #2c2727',
        }
    },
    btntext: {
        padding: '10px 15px',
    }
}));

export const DefaultButton = (props) => {
    const { onClick, variant, disabled } = props;
    const classes = useStyles();
    return (
        <Button
            disabled={disabled}
            onClick={onClick}
            classes={{ text: classes.btntext }}
            className={variant === 'dark' ? classes.defaultDarkBtn : classes.defaultLightBtn}>
            {props.children}
        </Button>
    )
}

DefaultButton.prototype = {
    variant: PropTypes.oneOf(['dark', 'light']).isRequired,
    disabled: PropTypes.bool
}

export const ModalCloseButton = (props) => {
    const { onClick } = props;

    return (
        <DefaultButton
            onClick={onClick}
            variant='dark'>
            Cancel
        </DefaultButton>
    )
}
export const ModalConfirmButton = (props) => {
    const { onClick } = props;

    return (
        <DefaultButton
            onClick={onClick}
            variant='light'>
            Confirm
        </DefaultButton>
    )
}

export const EditSettings = ({ onClick }) => {
    const classes = useStyles();

    return (
        <Button
            onClick={onClick}
            className={classes.editBtn}>
            Edit
        </Button>
    )
}

export const SignOutBtn = () => {
    const classes = useStyles();
    const { history } = useContext(store);
    const logout = () => {
        if (window.confirm('Are you sure?')) {
            signOut(history);
        }
    }
    return (
        <Button
            onClick={logout}
            className={classes.logoutBtn}>
            Sign Out
        </Button>
    )
}